import { NgModule } from '@angular/core';
import { SharedCommonModule } from './shared-common.module';


import { UserRouteAccessService } from './auth/user-route-access-service';

import { Principal } from './auth/principal.service';

import { AccountService } from './auth/account.service';

import { AuthServerProvider } from './auth/auth-jwt.service';

import { MustMatchDirective } from './directives/must-match.directive'; // Adjust the import path as needed

// import { ChartDirective } from '../chart.directive'; // Adjust the path if needed
import { TokenManagementComponent } from './utils/components/token-management/token-management.component';
@NgModule({
	imports: [
		SharedCommonModule,
	],
	providers: [
		Principal,
		AccountService,
		AuthServerProvider,
		UserRouteAccessService
	],
	exports: [
		SharedCommonModule,
		MustMatchDirective,
		TokenManagementComponent,
		// ChartDirective
	],
	declarations: [
		MustMatchDirective,
		TokenManagementComponent,
	]
})

export class SharedModule { }